import { ITheme, IStyle, mergeStyleSets, getTheme, Icon, MessageBarType } from '@fluentui/react';
import React from 'react';
import { JsxElement } from 'typescript';
import { getBwjAnnouncementBannerColorScheme } from '../bwj-announcement/color';

interface IBwjNoteProps {
  type: MessageBarType;
  textContent?: string | undefined;
  renderTextAsHtml?: boolean;
  smallText?: boolean; /**use small (not medium) text */
  interactiveContent?: JsxElement | undefined; /** will be wrapped in a p element */
  icon?: string | undefined;
  rootStyle?: React.CSSProperties | undefined;
}

const getStyleClasses = (theme: ITheme, messageType: MessageBarType, smallText: boolean) => {
  const colorScheme = getBwjAnnouncementBannerColorScheme(messageType);
  const contentFontSize = smallText ? theme.fonts.small.fontSize : theme.fonts.medium.fontSize;
  const contentLineHeight = smallText ? theme.fonts.smallPlus.lineHeight : theme.fonts.mediumPlus.lineHeight;
  const iconSize = smallText ? theme.fonts.large.fontSize : theme.fonts.xLarge.fontSize;

  const root: IStyle = {
    fontSize: contentFontSize,
    padding: '0.75em',
    display: 'flex',
    alignItems: 'stretch',
    border: '1px solid white',
    borderLeft: 'none',
    borderRight: 'none',
    backgroundColor: colorScheme.background,
    borderColor: colorScheme.main,
    color: colorScheme.main,

    '& > p': {
      fontSize: contentFontSize,
      lineHeight: contentLineHeight,
      margin: 0,
      padding: 0,
      marginLeft: '0.25em',
      flexGrow: 1,
    },
  };

  const iconContainer: IStyle = {
    theme: 0,
    padding: 0,
    paddingRight: '0.25em',

    '& > i': {
      fontSize: iconSize,
    },
  }

  return mergeStyleSets({
    root,
    iconContainer,
  });
}

const getIconForType = (type: MessageBarType) => {
  switch(type) {
    case MessageBarType.error: return 'ErrorBadge';
    case MessageBarType.blocked: return 'BlockedSite';
    case MessageBarType.warning: return 'Warning';
    case MessageBarType.severeWarning: return 'WarningSolid';
    case MessageBarType.success: return 'SkypeCircleCheck';
    default: return 'Info';
  }
};

export const BwjNote: React.FunctionComponent<IBwjNoteProps> = (props) => {
  const theme = getTheme();
  const cs = getStyleClasses(theme, props.type, props.smallText ?? false);
  const iconName = props.icon ?? getIconForType(props.type);

  return (
    <div className={cs.root}>
      <div className={cs.iconContainer}>
        <Icon
          iconName={iconName}
          aria-hidden={true}
        />
      </div>
      {!!props.textContent && props.renderTextAsHtml === true ?
      <p
        dangerouslySetInnerHTML={{ __html: props.textContent }}
      />
      :
      <p>
        {!!props.textContent ? props.textContent : undefined}
        {!!props.interactiveContent ? props.interactiveContent : undefined}
      </p>}
    </div>
  );
};
